// Temporary press build bridge — remove after migration
export const PREVIEW_GRAPH='/api/graphql';
export const PREVIEW_CHANNEL='press';
export const PREVIEW_GATE='lm-preview-7f3a';
export const PREVIEW_HEADER='X-Lumen-Preview';
